/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore

function addUserByLoyaltyCardQuery(loyaltyUserId?: string): DataServiceQuery {
    const key = loyaltyUserId ? { LoyaltyUserId: loyaltyUserId } : null;
    return new DataServiceQuery(
        '',
        'AddUserByLoyaltyCardSuccessEntity',
        DataServiceEntities.AddUserByLoyaltyCardSuccessEntityExtensionClass,
        key
    );
}

export function createAddUserByLoyaltyCardInput(loyaltyNumber: string, zipCode: string, email: string): IDataServiceRequest {
    const query = addUserByLoyaltyCardQuery();
    return query.createDataServiceRequestForOperation(
        'AddUserByLoyaltyCard',
        true,
        DataServiceEntities.AddUserByLoyaltyCardResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAddUserByLoyaltyCardResponse' },
        { loyaltyNumber: loyaltyNumber, zipCode: zipCode, email: email }
    );
}

export function addUserByLoyaltyCardAsync(
    context: IContext,
    loyaltyNumber: string,
    zipCode: string,
    email: string
): AsyncResult<DataServiceEntities.IAddUserByLoyaltyCardResponse> {
    const request = createAddUserByLoyaltyCardInput(loyaltyNumber, zipCode, email);
    return callActionOrExecute<DataServiceEntities.IAddUserByLoyaltyCardResponse>(request, context.callerContext);
}

// @ts-ignore
function mailChimpQuery(mailChimpApiKey?: string): DataServiceQuery {
    const key = mailChimpApiKey ? { MailChimpApiKey: mailChimpApiKey } : null;
    return new DataServiceQuery(
        'MailChimp',
        'MailChimpConfigurationEntity',
        DataServiceEntities.MailChimpConfigurationEntityExtensionClass,
        key
    );
}

export function createSubscribeToMailChimpInput(email: string, useDoubleOptIn: boolean, audience: string): IDataServiceRequest {
    const query = mailChimpQuery();
    return query.createDataServiceRequestForOperation(
        'SubscribeToMailChimp',
        false,
        DataServiceEntities.SubscribeToMailChimpResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISubscribeToMailChimpResponse' },
        { email: email, useDoubleOptIn: useDoubleOptIn, audience: audience }
    );
}

export function subscribeToMailChimpAsync(
    context: IContext,
    email: string,
    useDoubleOptIn: boolean,
    audience: string
): AsyncResult<DataServiceEntities.ISubscribeToMailChimpResponse> {
    const request = createSubscribeToMailChimpInput(email, useDoubleOptIn, audience);
    return callActionOrExecute<DataServiceEntities.ISubscribeToMailChimpResponse>(request, context.callerContext);
}

export function createGetMailChimpSubscriptionStatusInput(): IDataServiceRequest {
    const query = mailChimpQuery();
    return query.createDataServiceRequestForOperation(
        'GetMailChimpSubscriptionStatus',
        false,
        DataServiceEntities.GetMailChimpSubscriptionStatusResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetMailChimpSubscriptionStatusResponse' },
        {}
    );
}

export function getMailChimpSubscriptionStatusAsync(
    context: IContext
): AsyncResult<DataServiceEntities.IGetMailChimpSubscriptionStatusResponse> {
    const request = createGetMailChimpSubscriptionStatusInput();
    return callActionOrExecute<DataServiceEntities.IGetMailChimpSubscriptionStatusResponse>(request, context.callerContext);
}

export function createChangeMailChimpSubscriptionStatusInput(isSubscribe: boolean, isPhysical: boolean): IDataServiceRequest {
    const query = mailChimpQuery();
    return query.createDataServiceRequestForOperation(
        'ChangeMailChimpSubscriptionStatus',
        false,
        DataServiceEntities.MailChimpSubscriptionChangeResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMailChimpSubscriptionChangeResponse' },
        { isSubscribe: isSubscribe, isPhysical: isPhysical }
    );
}

export function changeMailChimpSubscriptionStatusAsync(
    context: IContext,
    isSubscribe: boolean,
    isPhysical: boolean
): AsyncResult<DataServiceEntities.IMailChimpSubscriptionChangeResponse> {
    const request = createChangeMailChimpSubscriptionStatusInput(isSubscribe, isPhysical);
    return callActionOrExecute<DataServiceEntities.IMailChimpSubscriptionChangeResponse>(request, context.callerContext);
}

// @ts-ignore
function k3InstructionIconTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'K3InstructionIconTable',
        'K3InstructionIconTable',
        DataServiceEntities.K3InstructionIconTableExtensionClass,
        key
    );
}

export function createGetAllInstructionIconTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3InstructionIconTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllInstructionIconTable',
        true,
        DataServiceEntities.K3InstructionIconTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InstructionIconTable' },
        {}
    );
}

export function getAllInstructionIconTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3InstructionIconTable[]> {
    const request = createGetAllInstructionIconTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3InstructionIconTable[]>(request, context.callerContext);
}

export function createGetInstructionIconTableByInstructionInput(
    queryResultSettings: IQueryResultSettings,
    instruction: number
): IDataServiceRequest {
    const query = k3InstructionIconTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetInstructionIconTableByInstruction',
        true,
        DataServiceEntities.K3InstructionIconTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InstructionIconTable' },
        { instruction: instruction }
    );
}

export function getInstructionIconTableByInstructionAsync(
    context: IContext,
    instruction: number
): AsyncResult<DataServiceEntities.IK3InstructionIconTable[]> {
    const request = createGetInstructionIconTableByInstructionInput(context.queryResultSettings || {}, instruction);
    return callActionOrExecute<DataServiceEntities.IK3InstructionIconTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3InstructionTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery('K3InstructionTable', 'K3InstructionTable', DataServiceEntities.K3InstructionTableExtensionClass, key);
}

export function createGetAllInstructionTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3InstructionTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllInstructionTable',
        true,
        DataServiceEntities.K3InstructionTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InstructionTable' },
        {}
    );
}

export function getAllInstructionTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3InstructionTable[]> {
    const request = createGetAllInstructionTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3InstructionTable[]>(request, context.callerContext);
}

export function createGetInstructionTableByInstructionInput(
    queryResultSettings: IQueryResultSettings,
    instructionId: string
): IDataServiceRequest {
    const query = k3InstructionTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetInstructionTableByInstruction',
        true,
        DataServiceEntities.K3InstructionTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InstructionTable' },
        { instructionId: instructionId }
    );
}

export function getInstructionTableByInstructionAsync(
    context: IContext,
    instructionId: string
): AsyncResult<DataServiceEntities.IK3InstructionTable[]> {
    const request = createGetInstructionTableByInstructionInput(context.queryResultSettings || {}, instructionId);
    return callActionOrExecute<DataServiceEntities.IK3InstructionTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3ProductWashCareTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'K3ProductWashCareTable',
        'K3ProductWashCareTable',
        DataServiceEntities.K3ProductWashCareTableExtensionClass,
        key
    );
}

export function createGetAllWashCareTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ProductWashCareTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllWashCareTable',
        true,
        DataServiceEntities.K3ProductWashCareTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductWashCareTable' },
        {}
    );
}

export function getAllWashCareTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ProductWashCareTable[]> {
    const request = createGetAllWashCareTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3ProductWashCareTable[]>(request, context.callerContext);
}

export function createGetProductWashCareByItemInput(queryResultSettings: IQueryResultSettings, itemId: string): IDataServiceRequest {
    const query = k3ProductWashCareTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetProductWashCareByItem',
        true,
        DataServiceEntities.K3ProductWashCareTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductWashCareTable' },
        { itemId: itemId }
    );
}

export function getProductWashCareByItemAsync(
    context: IContext,
    itemId: string
): AsyncResult<DataServiceEntities.IK3ProductWashCareTable[]> {
    const request = createGetProductWashCareByItemInput(context.queryResultSettings || {}, itemId);
    return callActionOrExecute<DataServiceEntities.IK3ProductWashCareTable[]>(request, context.callerContext);
}

export function createGetProductWashCareByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3ProductWashCareTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetProductWashCareByProduct',
        true,
        DataServiceEntities.K3ProductWashCareTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductWashCareTable' },
        { product: product }
    );
}

export function getProductWashCareByProductAsync(
    context: IContext,
    product: number
): AsyncResult<DataServiceEntities.IK3ProductWashCareTable[]> {
    const request = createGetProductWashCareByProductInput(context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ProductWashCareTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3BrandTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery('K3BrandTable', 'K3BrandTable', DataServiceEntities.K3BrandTableExtensionClass, key);
}

export function createGetAllK3BrandTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3BrandTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllK3BrandTable',
        true,
        DataServiceEntities.K3BrandTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3BrandTable' },
        {}
    );
}

export function getAllK3BrandTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3BrandTable[]> {
    const request = createGetAllK3BrandTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3BrandTable[]>(request, context.callerContext);
}

export function createGetK3BrandTableByBrandInput(queryResultSettings: IQueryResultSettings, brandId: string): IDataServiceRequest {
    const query = k3BrandTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetK3BrandTableByBrand',
        true,
        DataServiceEntities.K3BrandTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3BrandTable' },
        { brandId: brandId }
    );
}

export function getK3BrandTableByBrandAsync(context: IContext, brandId: string): AsyncResult<DataServiceEntities.IK3BrandTable[]> {
    const request = createGetK3BrandTableByBrandInput(context.queryResultSettings || {}, brandId);
    return callActionOrExecute<DataServiceEntities.IK3BrandTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3InventTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery('K3InventTable', 'K3InventTable', DataServiceEntities.K3InventTableExtensionClass, key);
}

export function createGetAllK3InventTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3InventTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllK3InventTable',
        true,
        DataServiceEntities.K3InventTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InventTable' },
        {}
    );
}

export function getAllK3InventTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3InventTable[]> {
    const request = createGetAllK3InventTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3InventTable[]>(request, context.callerContext);
}

export function createGetK3InventTableByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3InventTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetK3InventTableByProduct',
        true,
        DataServiceEntities.K3InventTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InventTable' },
        { product: product }
    );
}

export function getK3InventTableByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3InventTable[]> {
    const request = createGetK3InventTableByProductInput(context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3InventTable[]>(request, context.callerContext);
}

export function createGetK3InventTableByItemInput(queryResultSettings: IQueryResultSettings, itemId: string): IDataServiceRequest {
    const query = k3InventTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetK3InventTableByItem',
        true,
        DataServiceEntities.K3InventTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InventTable' },
        { itemId: itemId }
    );
}

export function getK3InventTableByItemAsync(context: IContext, itemId: string): AsyncResult<DataServiceEntities.IK3InventTable[]> {
    const request = createGetK3InventTableByItemInput(context.queryResultSettings || {}, itemId);
    return callActionOrExecute<DataServiceEntities.IK3InventTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3KRFInventTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery('K3KRFInventTable', 'K3KRFInventTable', DataServiceEntities.K3KRFInventTableExtensionClass, key);
}

export function createGetAllKRFInventTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3KRFInventTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllKRFInventTable',
        true,
        DataServiceEntities.K3KRFInventTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3KRFInventTable' },
        {}
    );
}

export function getAllKRFInventTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3KRFInventTable[]> {
    const request = createGetAllKRFInventTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3KRFInventTable[]>(request, context.callerContext);
}

export function createGetKRFInventTableByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3KRFInventTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetKRFInventTableByProduct',
        true,
        DataServiceEntities.K3KRFInventTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3KRFInventTable' },
        { product: product }
    );
}

export function getKRFInventTableByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3KRFInventTable[]> {
    const request = createGetKRFInventTableByProductInput(context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3KRFInventTable[]>(request, context.callerContext);
}

export function createGetKRFInventTableByItemInput(queryResultSettings: IQueryResultSettings, itemId: string): IDataServiceRequest {
    const query = k3KRFInventTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetKRFInventTableByItem',
        true,
        DataServiceEntities.K3KRFInventTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3KRFInventTable' },
        { itemId: itemId }
    );
}

export function getKRFInventTableByItemAsync(context: IContext, itemId: string): AsyncResult<DataServiceEntities.IK3KRFInventTable[]> {
    const request = createGetKRFInventTableByItemInput(context.queryResultSettings || {}, itemId);
    return callActionOrExecute<DataServiceEntities.IK3KRFInventTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3CSRClassificationIconTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'K3CSRClassificationIconTable',
        'K3CSRClassificationIconTable',
        DataServiceEntities.K3CSRClassificationIconTableExtensionClass,
        key
    );
}

export function createGetAllCSRClassificationIconTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3CSRClassificationIconTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllCSRClassificationIconTable',
        true,
        DataServiceEntities.K3CSRClassificationIconTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3CSRClassificationIconTable' },
        {}
    );
}

export function getAllCSRClassificationIconTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3CSRClassificationIconTable[]> {
    const request = createGetAllCSRClassificationIconTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3CSRClassificationIconTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3CSRClassificationTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'K3CSRClassificationTable',
        'K3CSRClassificationTable',
        DataServiceEntities.K3CSRClassificationTableExtensionClass,
        key
    );
}

export function createGetAllCSRClassificationTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3CSRClassificationTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllCSRClassificationTable',
        true,
        DataServiceEntities.K3CSRClassificationTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3CSRClassificationTable' },
        {}
    );
}

export function getAllCSRClassificationTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3CSRClassificationTable[]> {
    const request = createGetAllCSRClassificationTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3CSRClassificationTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3CSRClassificationTranslationTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'K3CSRClassificationTranslationTable',
        'K3CSRClassificationTranslationTable',
        DataServiceEntities.K3CSRClassificationTranslationTableExtensionClass,
        key
    );
}

export function createGetAllCSRClassificationTranslationTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3CSRClassificationTranslationTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllCSRClassificationTranslationTable',
        true,
        DataServiceEntities.K3CSRClassificationTranslationTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3CSRClassificationTranslationTable' },
        {}
    );
}

export function getAllCSRClassificationTranslationTableAsync(
    context: IContext
): AsyncResult<DataServiceEntities.IK3CSRClassificationTranslationTable[]> {
    const request = createGetAllCSRClassificationTranslationTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3CSRClassificationTranslationTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3ProductCSRClassificationsTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'K3ProductCSRClassificationsTable',
        'K3ProductCSRClassificationsTable',
        DataServiceEntities.K3ProductCSRClassificationsTableExtensionClass,
        key
    );
}

export function createGetAllProductCSRClassificationTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ProductCSRClassificationsTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllProductCSRClassificationTable',
        true,
        DataServiceEntities.K3ProductCSRClassificationsTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductCSRClassificationsTable' },
        {}
    );
}

export function getAllProductCSRClassificationTableAsync(
    context: IContext
): AsyncResult<DataServiceEntities.IK3ProductCSRClassificationsTable[]> {
    const request = createGetAllProductCSRClassificationTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3ProductCSRClassificationsTable[]>(request, context.callerContext);
}

export function createGetProductCSRClassificationTableByProductInput(
    queryResultSettings: IQueryResultSettings,
    product: number
): IDataServiceRequest {
    const query = k3ProductCSRClassificationsTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetProductCSRClassificationTableByProduct',
        true,
        DataServiceEntities.K3ProductCSRClassificationsTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductCSRClassificationsTable' },
        { product: product }
    );
}

export function getProductCSRClassificationTableByProductAsync(
    context: IContext,
    product: number
): AsyncResult<DataServiceEntities.IK3ProductCSRClassificationsTable[]> {
    const request = createGetProductCSRClassificationTableByProductInput(context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ProductCSRClassificationsTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3CompositionTypeTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'K3CompositionTypeTable',
        'K3CompositionTypeTable',
        DataServiceEntities.K3CompositionTypeTableExtensionClass,
        key
    );
}

export function createGetAllCompositionTypeTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3CompositionTypeTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllCompositionTypeTable',
        true,
        DataServiceEntities.K3CompositionTypeTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3CompositionTypeTable' },
        {}
    );
}

export function getAllCompositionTypeTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3CompositionTypeTable[]> {
    const request = createGetAllCompositionTypeTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3CompositionTypeTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3FibreTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery('K3FibreTable', 'K3FibreTable', DataServiceEntities.K3FibreTableExtensionClass, key);
}

export function createGetAllFibreTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3FibreTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllFibreTable',
        true,
        DataServiceEntities.K3FibreTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3FibreTable' },
        {}
    );
}

export function getAllFibreTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3FibreTable[]> {
    const request = createGetAllFibreTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3FibreTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3FibreTranslationTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'K3FibreTranslationTable',
        'K3FibreTranslationTable',
        DataServiceEntities.K3FibreTranslationTableExtensionClass,
        key
    );
}

export function createGetAllFibreTranslationTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3FibreTranslationTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllFibreTranslationTable',
        true,
        DataServiceEntities.K3FibreTranslationTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3FibreTranslationTable' },
        {}
    );
}

export function getAllFibreTranslationTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3FibreTranslationTable[]> {
    const request = createGetAllFibreTranslationTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3FibreTranslationTable[]>(request, context.callerContext);
}

// @ts-ignore
function k3ProductCompositionTableQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'K3ProductCompositionTable',
        'K3ProductCompositionTable',
        DataServiceEntities.K3ProductCompositionTableExtensionClass,
        key
    );
}

export function createGetAllProductCompositionTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ProductCompositionTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllProductCompositionTable',
        true,
        DataServiceEntities.K3ProductCompositionTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductCompositionTable' },
        {}
    );
}

export function getAllProductCompositionTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ProductCompositionTable[]> {
    const request = createGetAllProductCompositionTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IK3ProductCompositionTable[]>(request, context.callerContext);
}

export function createGetProductCompositionTableByProductInput(
    queryResultSettings: IQueryResultSettings,
    product: number
): IDataServiceRequest {
    const query = k3ProductCompositionTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetProductCompositionTableByProduct',
        true,
        DataServiceEntities.K3ProductCompositionTableExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductCompositionTable' },
        { product: product }
    );
}

export function getProductCompositionTableByProductAsync(
    context: IContext,
    product: number
): AsyncResult<DataServiceEntities.IK3ProductCompositionTable[]> {
    const request = createGetProductCompositionTableByProductInput(context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ProductCompositionTable[]>(request, context.callerContext);
}

// @ts-ignore
function helpDeskControllerQuery(replicationCounterFromOrigin?: number): DataServiceQuery {
    const key = replicationCounterFromOrigin ? { ReplicationCounterFromOrigin: replicationCounterFromOrigin } : null;
    return new DataServiceQuery('HelpDeskController', 'HelpDeskFormEntity', DataServiceEntities.HelpDeskFormEntityExtensionClass, key);
}

export function createCreateHelpDeskFormEntityInput(
    firstname: string,
    lastname: string,
    email: string,
    phone: string,
    inquiryType: string,
    body: string
): IDataServiceRequest {
    const query = helpDeskControllerQuery();
    return query.createDataServiceRequestForOperation(
        'CreateHelpDeskFormEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { firstname: firstname, lastname: lastname, email: email, phone: phone, inquiryType: inquiryType, body: body }
    );
}

export function createHelpDeskFormEntityAsync(
    context: IContext,
    firstname: string,
    lastname: string,
    email: string,
    phone: string,
    inquiryType: string,
    body: string
): AsyncResult<boolean> {
    const request = createCreateHelpDeskFormEntityInput(firstname, lastname, email, phone, inquiryType, body);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

// @ts-ignore
function birthdayQuery(accountNum?: number): DataServiceQuery {
    const key = accountNum ? { AccountNum: accountNum } : null;
    return new DataServiceQuery('Birthday', 'BirthdayEntity', DataServiceEntities.BirthdayEntityExtensionClass, key);
}

export function createGetUserBirthdayInput(accountNum: string): IDataServiceRequest {
    const query = birthdayQuery();
    return query.createDataServiceRequestForOperation(
        'GetUserBirthday',
        false,
        DataServiceEntities.GetBirthdayResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetBirthdayResponse' },
        { accountNum: accountNum }
    );
}

export function getUserBirthdayAsync(context: IContext, accountNum: string): AsyncResult<DataServiceEntities.IGetBirthdayResponse> {
    const request = createGetUserBirthdayInput(accountNum);
    return callActionOrExecute<DataServiceEntities.IGetBirthdayResponse>(request, context.callerContext);
}

export function createSetUserBirthdayInput(day: number, month: number, year: number, accountNum: string): IDataServiceRequest {
    const query = birthdayQuery();
    return query.createDataServiceRequestForOperation(
        'SetUserBirthday',
        false,
        DataServiceEntities.SetBirthdayResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISetBirthdayResponse' },
        { day: day, month: month, year: year, accountNum: accountNum }
    );
}

export function setUserBirthdayAsync(
    context: IContext,
    day: number,
    month: number,
    year: number,
    accountNum: string
): AsyncResult<DataServiceEntities.ISetBirthdayResponse> {
    const request = createSetUserBirthdayInput(day, month, year, accountNum);
    return callActionOrExecute<DataServiceEntities.ISetBirthdayResponse>(request, context.callerContext);
}
